import { Check } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { LogoMark, Wordmark, VARIANTS, setVariant, useBrand } from "@/components/Logo";
import { useLang } from "@/i18n";
import { cn } from "@/lib/utils";

const Card = ({ k, v, active, onPick, t }) => (
  <div className={cn("erp-card overflow-hidden flex flex-col", active && "ring-2 ring-blue-700")} data-testid={`brand-variant-${k}`}>
    <div className="px-5 py-3 border-b border-slate-200 dark:border-slate-800 flex items-center justify-between">
      <h3 className="font-heading font-semibold">{v.name}</h3>
      {active && <span className="text-xs font-semibold text-blue-700 inline-flex items-center gap-1"><Check size={14} />{t("brand_active")}</span>}
    </div>
    <div className="p-6 bg-white flex items-center gap-4"><LogoMark size={56} variant={v} /><Wordmark variant={v} className="text-5xl text-slate-900" /></div>
    <div className="p-6 flex items-center gap-4" style={{ background: v.bg }}><LogoMark size={56} inverted variant={v} /><Wordmark variant={v} className="text-5xl text-white" /></div>
    <div className="p-6 bg-slate-100 dark:bg-slate-800 flex items-end gap-6">
      <div className="flex items-center gap-2"><LogoMark size={28} variant={v} /><Wordmark variant={v} className="text-xl" /></div>
      <div className="flex items-center gap-2"><LogoMark size={20} variant={v} /><Wordmark variant={v} className="text-sm" /></div>
      <LogoMark size={16} variant={v} />
    </div>
    <div className="p-4 mt-auto flex items-center justify-between">
      <div className="flex gap-1.5">{[v.bg, v.accent].map((c) => <span key={c} className="w-6 h-6 rounded-full border border-black/10" style={{ background: c }} title={c} />)}</div>
      <Button size="sm" onClick={onPick} disabled={active} className="bg-blue-800 hover:bg-blue-700" data-testid={`brand-pick-${k}`}>{t("brand_pick")}</Button>
    </div>
  </div>
);

export default function Brand() {
  const { t } = useLang();
  const current = useBrand();
  const pick = (k) => { setVariant(k); toast.success(t("brand_saved")); };
  return (
    <div className="space-y-5 page-enter" data-testid="brand-page">
      <p className="text-sm text-slate-500 max-w-2xl">{t("brand_hint")}</p>
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-5">
        {Object.entries(VARIANTS).map(([k, v]) => <Card key={k} k={k} v={v} t={t} active={current === v} onPick={() => pick(k)} />)}
      </div>
    </div>
  );
}
